import { documentToReactComponents } from "@/components/content/rich-text";
import { richContentOptions } from "@/components/content-options";

export default function SEO(props) {
  return (
    <div className="invisible h-0">
      {documentToReactComponents(
        props.fields.content,
        richContentOptions
      )}
    </div>
  );
}
